"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResult = exports.SearchQuery = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const dealer_1 = require("../../shared/dealer");
exports.NAMESPACE = 'Culligan.Api.V1.Frontend.Dealer.Schema';
const cleaning = 'Case is ignored. Every character that is not an ASCII letter or digit (A-Z, a-z, 0-9) is removed before matching, accented letters included; the 2-character minimum is checked before that, so a term made only of other characters becomes empty and matches every location that has a value in that field.';
const searchTerm = (description) => effect_1.Schema.optionalWith(effect_1.Schema.Union(effect_1.Schema.Literal(''), effect_1.Schema.String.pipe(effect_1.Schema.minLength(2))), {
    exact: true,
}).annotations({
    description: `${description} ${cleaning}`,
});
exports.SearchQuery = effect_1.Schema.Struct({
    code: searchTerm('Part of the dealer code, at least 2 characters; an empty value is ignored.'),
    name: searchTerm('Part of the dealer name, at least 2 characters; an empty value is ignored.'),
    contactPersonName: searchTerm('Part of the contact person name, at least 2 characters; an empty value is ignored.'),
    email: searchTerm('Part of the dealer email, at least 2 characters; an empty value is ignored. A full address never matches, because "@" and "." are removed from the term but stay in the stored value.'),
    country: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
        description: 'Exact country value, case is ignored. Not length-checked.',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.SearchQuery`,
    description: 'Optional filters for the dealer location search',
});
exports.SearchResult = effect_1.Schema.Struct({
    items: effect_1.Schema.propertySignature(effect_1.Schema.Array(dealer_1.Location)).annotations({
        description: 'Dealer locations that match every given filter. With no filters, every stored location is returned.',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.SearchResult`,
    description: 'Dealer locations found by the search',
});
//# sourceMappingURL=schema.js.map